<ng-template>
  <div class="Stepper-Item">
    <ng-content></ng-content>
  </div>
</ng-template>